// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"13":"5794a975","106":"2fff2a90","195":"8e4b835c","206":"1410ede1","272":"afc33bfd","385":"1d1e4313","464":"fa45953f","657":"41178b32","731":"11059183","838":"1135d32c","886":"faef6158","979":"acd4cc8a","985":"0177e57e"}[chunkId] + ".js";
};